import { render, staticRenderFns } from "./CoachesSalary.vue?vue&type=template&id=f1d64e78"
import script from "./CoachesSalary.vue?vue&type=script&lang=js"
export * from "./CoachesSalary.vue?vue&type=script&lang=js"
import style0 from "./CoachesSalary.vue?vue&type=style&index=0&id=f1d64e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports